import React, {useState , useEffect} from 'react';
import "./Loading.scss";

export default function Loading() {
    let [load ,setLoad ] = useState(true)
    let [goup ,setGoup ] = useState(false)

    let [finishedLoadingFade ,setFinishedLoadingFade ] = useState(false)
    useEffect(() => {
        setTimeout(() => {
            setLoad(false)
        },3000)
    }, [])
    useEffect(() => {
        setTimeout(() => {
            setGoup(true)
        },5000)
    }, [])
    useEffect(() => {
        setTimeout(() => {
            setFinishedLoadingFade(true)
        },6000)
    }, [])

    return (
        <section className={`loading ${finishedLoadingFade && "fade"} `}>
            <div className="jelly_wrapper">
                {
                    load ? <div className="jelly"></div> :
                    <div className={`jelly_end  ${goup && "go_up"}`}></div>
                }
                {
                    load ? <div className="load_text">
                                <div>הסביבה בטעינה</div>
                                <div className="dot_wrapper">
                                    <div className="dot"></div>
                                    <div className="dot"></div>
                                    <div className="dot"></div>
                                </div>
                            </div> : 
                    <div className="load_text">התחברת בהצלחה!</div>
                }
                
                
            </div>
        </section>
    )
}
